// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAs } from "../../../icons/mono/build/icon-as.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AsIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAs.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AsIcon.displayName = 'AsIcon';
}

export default AsIcon;